import React, {useState, useEffect, useRef} from 'react'
import firebase from '../../firebase/config'
import {useHistory, Link} from 'react-router-dom';
import Compress from "react-image-file-resizer";


function Employes() {

    const history = useHistory()
    const [aliados, setAliados] = useState([])
    const [roles, setRoles] = useState([])
    const [user, setUser] = useState({})
    const [aliado, setAliado] = useState({})
    const [rolSelected, setRolSelected] = useState("")
    const [success, setSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [empleadoInfo, setEmpleadoInfo] = useState({
      nombre: "",
      nombreComercial: "",
      telefono: "",
      identificacion: "",
      direccion: ""
    })

    const hiddenFileInput = React.useRef(null);

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
  
    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    async function handleChange(e) {
      var file = e.target.files[0]
      Compress.imageFileResizer(
        file,
        600,
        300,
        "JPEG",
        10,
        0,
        (uri) => {
          setFile(uri)
          console.log(uri)
        },
        "file",
        600,
        300
      )
      setImg(URL.createObjectURL(file))
    }  

    const getAliados = async(aliadoId) =>{
      let tipos = [];
      
      const reference = firebase.db.collection('Aliados').doc(aliadoId).collection("Usuarios")

      await reference.get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
        })
        getSubAliados(tipos)
      })
    }
    
    const getRoles = async(aliadoId) =>{
      let tipos = [];

      await firebase.db.collection('Roles').where("aliadoId", "==", aliadoId).get().then(val => {
        val.docs.forEach(item=>{
          tipos.push(item.data())
        })
        setRoles(tipos)
      })
    }
    
    function getNameRole(r){
      let a = ""
      firebase.db.collection('Roles').doc(r).get().then(val => {
        a = val.data().roleNombre
      })
      return a
    }
    
    const getSubAliados = async(a) =>{
      let tipos = [];
      
      await Promise.all(a.map(async (ai) => {
        await firebase.db.collection("Aliados").doc(ai.aliadoId).get().then(async(val)=>{
          let o = {...val.data()}
          let a
          val.data().role !== "" && await firebase.db.collection('Roles').doc(val.data().role).get().then(v => {
            a = v.data().roleNombre
          })
          o["roleName"] = a
          console.log(val.data())
          tipos.push(o)
         })
      }))
      setAliados(tipos)

    }
    
    async function changeAliado(al){
      
      setAliado(al)
      if(aliado.roleName !== "" || aliado.roleName !== undefined){
        try{
          await firebase.db.collection("Roles").doc(al.role).get().then((val)=>{
            let v = val.data()
            setAliado({...al, rol: v})
          })
          getRoles(user.aliadoId)
        }catch(e){
          console.log("Error: " + e)
        }
      }else{
        let v = undefined
        setAliado({...al, rol: v})
        getRoles(user.aliadoId)
      }
    }

    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getAliados(val.aliadoId)
          getRoles(val.aliadoId)
        });
    }, [])

    return (

        <div className="main-content-container container-fluid px-4">
          {success && <SuccessComponent msg={successMsg === "" ? "Empleado actualizado exitosamente" : successMsg}/>}
          {aliado.aliadoId === undefined
          ? 
          <div>

              <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <p className="page-title">Administrador de usuarios</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-1 mb-0">
                  <div className="row align-items-center justify-content-space-around">
                  </div>
                </div>
              </div>
              <div className="form-row align-items-center justify-content-space-between mb-4">
                <Link to="/create-role" className="btn btn-secondary mr-3">Crear rol</Link>
                <Link to="/create-user" className="btn btn-outline-secondary">Agregar usuario</Link>
              </div>
              <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="mb-2 row orders-title">
                      <div className="col-md-1 ">
                        <p className="mb-2"></p>
                      </div>
                      <div className="col-md-3 ">
                        <p className="mb-2">Nombre del usuario</p>
                      </div>
                      <div className="col-md-3 ">
                        <p className="mb-2">Correo electronico</p>
                      </div>
                      <div className="col-md-2 ">
                        <p className="mb-2">Rol del usuario</p>
                      </div>
                      <div className="col-md-2 ">
                        <p className="mb-2"></p>
                      </div>
                      <div className="col-md-1 ">
                        <p className="mb-2"></p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="orders-container">
                      {
                        aliados.length > 0 ? aliados.map(aliado=>{
                          return(
                            <div onClick={()=>{changeAliado(aliado)}} key={aliado.aliadoId} className="mb-2 row order-child align-items-center">
                              <div className="col-md-1 color-primary">
                                <img className="client-avatar-preview rounded-circle mr-2" src={aliado.avatar ?? "cargando"} alt="Aliado Avatar"/>
                              </div>
                              <div className="col-md-3 ">
                                <p className="mb-0">{aliado.nombre}</p>
                              </div>
                              <div className="col-md-3 ">
                                <p className="mb-0">{aliado.email}</p>
                              </div>
                              <div className="col-md-2 color-success">
                                <p className="creation-input-label-pill" style={{textAlign: "center"}}>{aliado.role === "" ? "Sin rol" : aliado.roleName}</p>
                              </div>
                              <div className="col-md-2 ">
                                <p className="mb-0"></p>
                              </div>
                              <div className="col-md-1">
                                <p className="mb-0 material-icons">visibility</p>
                              </div>
                            </div>
                          )
                        }) : <div className="text-center"><p>No hay aliados</p></div>
                      }
                    </div>
                  </div>
              </div>
            </div>
            
            
            : <div>

              <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                  <div className="row align-items-center">
                    <div className="col">
                      {/* Administrador de usuarios */}
                      <p onClick={()=>{setAliado({}); setRolSelected("")}} className="page-title"><i className="material-icons">arrow_back</i> Regresar</p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-1 mb-0">
                  <div className="row align-items-center justify-content-space-around">
                    <i className="material-icons color-white display-5">help_outline</i>
                  </div>
                </div>
              </div>
              
              <div className="px-5">
              
                <div className="row justify-content-space-around no-gutters">
                  <div className="col-lg-3">

                  <input type="file"
                    ref={hiddenFileInput}
                    onChange={handleChange} 
                    style={{display: 'none'}}
                  />

                  <img onClick={handleClick}  style={{width: "200px", height: "200px"}} className="calendar-component-right-info-appointment-header-img cursor-pointer" src={src !== "" ? src : aliado.avatar} alt="" />

                  </div>
                  <div className="col-lg-8">
                    <div className="row no-gutters justify-content-spacebetween">
                      
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Nombre del empleado</p>
                        <input onChange={(e)=>{ setEmpleadoInfo({...empleadoInfo, nombre: e.target.value}) }} className="form-control" type="text" defaultValue={aliado.nombre}/>
                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Rol</p>
                        { aliado.rol !== undefined && <select className="form-control" onChange={(e)=>{setRolSelected( e.target.value )}}>
                          <option value={aliado.rol.roleId}>{aliado.rol.roleNombre }</option>
                          {roles.map((data)=>{
                            return (
                              (aliado.rol.roleId !== data.roleId) && <option key={data.roleId} value={data.roleId}>{data.roleNombre}</option>
                            )
                          })}
                        </select> }
                        { aliado.rol === undefined && <select className="form-control" onChange={(e)=>{setRolSelected( e.target.value )}}>
                          {roles.map((data)=>{
                            return (
                              <option key={data.roleId} value={data.roleId}>{data.roleNombre}</option>
                            )
                          })}
                        </select> }

                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">email</p>
                        <p className="color-primary light mb-0">{aliado.email}</p>
                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Tipo de aliado</p>
                        <p className="color-primary light mb-0">{aliado.tipoAliado}</p>
                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Teléfono</p>
                        <input onChange={(e)=>{ setEmpleadoInfo({...empleadoInfo, telefono: e.target.value}) }} className="form-control" type="text" defaultValue={aliado.telefono}/>
                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Dirección</p>
                        <input onChange={(e)=>{ setEmpleadoInfo({...empleadoInfo, direccion: e.target.value}) }} className="form-control" type="text" defaultValue={aliado.direccion}/>
                      </div>
                      <div className="col-lg-5 mb-4">
                        <p className="mb-2 calendar-component-appointment-card-title">Identificación</p>
                        <input onChange={(e)=>{ setEmpleadoInfo({...empleadoInfo, identificacion: e.target.value}) }} className="form-control" type="text" defaultValue={aliado.identificacion}/>
                      </div>

                    </div>

                    <div onClick={()=>{ updateUser() }} className="btn btn-primary">
                      Actualizar empleado
                    </div>

                  </div>
                </div>

              </div>

            </div>}

          </div>
    )

    async function updateUser(){
      if(file){
        await firebase.storage.ref(`/Aliados imagenes/${file.name}`).put(file)
        firebase.storage.ref("Aliados imagenes").child(file.name).getDownloadURL().then((urlI) => {
          
          try{
            firebase.db.collection("Aliados").doc(aliado.aliadoId).update({
              avatar: urlI,
              nombre: empleadoInfo.nombre !== "" ? empleadoInfo.nombre : aliado.nombre,
              nombreComercial: empleadoInfo.nombre !== "" ? empleadoInfo.nombre : aliado.nombre,
              telefono: empleadoInfo.telefono !== "" ? empleadoInfo.telefono : aliado.telefono,
              identificacion: empleadoInfo.identificacion !== "" ? empleadoInfo.identificacion : aliado.identificacion,
              direccion: empleadoInfo.direccion !== "" ? empleadoInfo.direccion : aliado.direccion,
              role: rolSelected !== "" ? rolSelected : aliado.rol.roleId,
            })
          }catch(e){
            console.log("Error: " + e)
          }

        })
      }else{
        
        try{
          await firebase.db.collection("Aliados").doc(aliado.aliadoId).update({
            nombre: empleadoInfo.nombre !== "" ? empleadoInfo.nombre : aliado.nombre,
            nombreComercial: empleadoInfo.nombre !== "" ? empleadoInfo.nombre : aliado.nombre,
            telefono: empleadoInfo.telefono !== "" ? empleadoInfo.telefono : aliado.telefono,
            identificacion: empleadoInfo.identificacion !== "" ? empleadoInfo.identificacion : aliado.identificacion,
            direccion: empleadoInfo.direccion !== "" ? empleadoInfo.direccion : aliado.direccion,
            role: rolSelected !== "" ? rolSelected : aliado.rol.roleId,
          })
        }catch(e){
          console.log("Error: " + e)
        }

      }

      setSuccessMsg("Empleado actualizado exitosamente")
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 4000);

    }


}

export default Employes